import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-add-edit-international-tax-config',
  templateUrl: './add-edit-international-tax-config.component.html',
  styleUrls: ['./add-edit-international-tax-config.component.scss']
})
export class AddEditInternationalTaxConfigComponent implements OnInit {
  taxTypeform: UntypedFormGroup;
  apisub:Subscription
  constructor(private apiservice: ApiService,private fb: UntypedFormBuilder,@Inject(MAT_DIALOG_DATA) public parentdata:any, private loaderservice: LoaderServiceService) {
    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_CONFIGURATION){
        if(resdata.result){
          // this.loaderservice.showLoader = false
          // this.activemodal.close({msg: 'success'})
          this.parentdata.ref.closeAll()
        }
      }
    })
    this.taxTypeform = this.fb.group({
      types: this.fb.array([this.createItemForTaxType()])
    });
   }

  ngOnInit(): void {
    if(this.parentdata.taxData.tax_types){
      this.taxTypeform = this.fb.group({
        types: this.fb.array([])
      });
      this.parentdata.taxData.tax_types.forEach((element:any) => {
        if(element){
          this.types.push(this.createFieldWithItemForTaxType(element));
        }
        // if(element.current_status == 3){
        // }
      });
    }
  }

  onSaveInternationalTax(){
    let obj = {
      "entity_hash": this.parentdata.entityHash,
      "tax_collection_status": this.parentdata.taxData?.tax_collection_status  ? this.parentdata.taxData?.tax_collection_status : 0,
      "tax_types": this.taxTypeform.get('types')!.value.map((item:any) => {
        return {
          "tax_type": item.tax_type, 
          "identification_no": item.identification_no ?? '',
        }
      }),
      "bill_invoice_type": this.parentdata.taxData?.bill_invoice_type ?? 1,
  }
  
  console.log(obj);
  
  this.loaderservice.showLoader = true
  this.apiservice.addEditInternationalEntityTaxConfiguration(obj)
  
  }

  // Create a new form group for each item
  itemOptions: string[] = ['Item1', 'Item2', 'Item3', 'Item4'];  // List of options
  filteredOptions: Observable<any[]>[] = [];
  createItemForTaxType(): UntypedFormGroup {
  const itemGroup = this.fb.group({
    tax_type: ['', Validators.required],
    identification_no: ['', Validators.required],
  });

  return itemGroup;

  }

  createFieldWithItemForTaxType(item:any): UntypedFormGroup {
  const itemGroup = this.fb.group({
    tax_type: [item.taxation_type, Validators.required],
    identification_no: [item.identification_no, Validators.required],
  });

  return itemGroup;
  }

  get types(): UntypedFormArray {
    return this.taxTypeform.get('types') as UntypedFormArray;
  }

    // Add new form field
addTaxTypeField(): void {
  this.types.push(this.createItemForTaxType());
}
// Remove a form field by index
removeFormFieldForTypes(index: number): void {
    
  this.types.removeAt(index);
}

}
